import { masterClient } from '~/core/utils/clients/masterClient'

const RESOURCE = '/profile'

export default {
  post() {
    return masterClient.post(`${RESOURCE}/logout/`, { }, { camelize: true })
  },
}
